// -*-mode: rjsx -*-
// REACT
import React, { useEffect } from "react"
// eslint-disable-next-line
import clsx from "clsx"

// MUI
// eslint-disable-next-line
import { withStyles, createStyles, makeStyles } from "@material-ui/core/styles"
// eslint-disable-next-line
import Typography from "@material-ui/core/Typography"


// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"
// eslint-disable-next-line
import red from "@material-ui/core/colors/red"

// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"

const useDefaultStyles = makeStyles(theme => ({
    headerDiv: {
        //
        // mobile
        //
        marginTop: 0,
        marginBottom: 10,
        marginLeft: 20,
        marginRight: 20,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            marginLeft: 0,
            marginRight: 0,
        }
    },
    headerText_before: {
        fontSize: 30,
        fontWeight: 700,
        lineHeight: 1.1,
        color: grey[800],
    },

    headerText: {
        fontSize: 24,
        fontWeight: 700,
        lineHeight: 1.1,
        fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
        //lineHeight: 28,
        // color: grey[800],
        color: "#1c1e21"
    },
    
}), { name: "FlashHeader" })

// keep adding this stuff

let FlashHeader = (props) => {

    // eslint-disable-next-line
    const { text, style } = props

    const classes = {
        ...useDefaultStyles(),
    }

    useEffect(() => {
    })

    return (
        <div className={classes.headerDiv}>
          <Typography className={classes.headerText} variant="h6" style={style}>
          {text}
        </Typography>
        </div>        
    )
}

export default FlashHeader

